import React from "react";
import { Outlet } from "react-router-dom";
import MFooterNavigation from "../ui/atoms/MFooterNavigation";

/**
 * HomeLayout: Used for home/dashboard/root screens.
 * Renders header (if any) and persistent footer navigation.
 */
const HomeLayout: React.FC = () => {
  return (
    <div className="flex flex-col bg-white curvy-gradient-onboarding">
      <main
        className="flex-1 overflow-auto overflow-x-hidden"
        style={{ maxHeight: "calc(var(--vh, 1vh) * 100 - 64px)" }}
      >
        <Outlet />
      </main>
      <MFooterNavigation />
    </div>
  );
};

export default HomeLayout;
